import { mergeWithMetadata } from '@digitaix/helpers';
import { STEP_METADATA_KEY } from './metadata-keys';

export function Step(stepIndex: number) {
  return function(target: any, propertyKey: string) {
    mergeWithMetadata(
      STEP_METADATA_KEY,
      { [stepIndex.toFixed(0)]: [propertyKey] },
      target
    );
  };
}
